import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres31x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres31x/labels')
  },
  getDetailTab1 () {
    if (isMock) return generator(mocker.detailTab1())
    return instance().get(endpoint + '/hres31x/tab1')
  },
  getDetailTab2_19 () {
    if (isMock) return generator(mocker.detailTab2_19())
    return instance().get(endpoint + '/hres31x/detail')
  },
  getDetailTab13Popup (popupParams) {
    let searchParams = {}
    if (typeof popupParams !== 'undefined') {
      searchParams = {
        p_codtency: (typeof popupParams.codtency !== 'undefined' ? popupParams.codtency : '')
      }
    }
    if (isMock) return generator(mocker.detailTab13Popup())
    const params = searchParams.p_codtency
    return instance().get(endpoint + '/hres31x/detailTab13Popup/' + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres31x/index.js